import { render, staticRenderFns } from "./TermosDeAceiteFinx.vue?vue&type=template&id=a53147aa&scoped=true"
import script from "./TermosDeAceiteFinx.vue?vue&type=script&lang=ts"
export * from "./TermosDeAceiteFinx.vue?vue&type=script&lang=ts"
import style0 from "./TermosDeAceiteFinx.vue?vue&type=style&index=0&id=a53147aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53147aa",
  null
  
)

export default component.exports